// extracted by mini-css-extract-plugin
export default {"btn":"BotonSkills_btn__vo4K+","selectedSkill":"BotonSkills_selectedSkill__3FKEb"};